var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer"},[_c('div',[_c('div',[_vm._v("kundenId="+_vm._s(_vm.customer.kundenId))]),_c('div',[_vm._v("keycloakId="+_vm._s(_vm.customer.keycloakId))])]),_c('div',[_c('div',[_vm._v("lastLogin="+_vm._s(_vm.customer.lastLogin))]),_c('div',[_vm._v("lastFailedLogin="+_vm._s(_vm.customer.lastFailedLogin))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }